import { bankLabel } from '../../utils/bank';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import BankScopeField from '../../components/BankScopeField';
import ScopeField from '../../components/ScopeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { fetchTicketsVendus } from '../../api/ticketsVendus';
import { fetchTicketDetail } from '../../api/salesMonitoring';
import TicketViewModal from '../../components/TicketViewModal';
import { downloadCSV } from '../../utils/csv';
import { todayISO } from '../../utils/date';
import './TicketsVendusPage.css';

const statutOptions = ['Valide', 'Annules', 'Tout'];
const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const TicketsVendusPage = () => {
  const [filter, setFilter] = useState('Tout');
  const [scopeId, setScopeId] = useState('');
  const [scopeName, setScopeName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [lotteryFrom, setLotteryFrom] = useState('');
  const [lotteryFromName, setLotteryFromName] = useState('');
  const [lotteryUp, setLotteryUp] = useState('');
  const [lotteryUpName, setLotteryUpName] = useState('');
  const [statut, setStatut] = useState('Valide');

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [openTicketId, setOpenTicketId] = useState(null);

  const filterApiValue = () => {
    if (filter === 'Groupe') return 'Group';
    if (filter === 'Superviseur') return 'Supervisor';
    if (filter === 'Banque') return 'Bank';
    return 'All';
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await fetchTicketsVendus({
        date, filter: filterApiValue(), scope: filter === 'Tout' ? undefined : scopeId,
        tirageFrom: lotteryFrom, tirageUp: lotteryUp, statut,
      });
      setData(result);
    } catch (err) {
      setError('Recherche impossible.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    if (!data || data.rows.length === 0) return;
    const header = ['Date', 'Banque', 'SQ', 'No', 'Loterie', 'O/L', 'Montant', 'Heure', 'Annule'];
    downloadCSV('tickets-vendus.csv', [
      ['Tickets Vendus'], [`Date : ${data.date}`], [],
      header,
      ...data.rows.map((r) => [
        r.date, `${bankLabel(r.bank_seq, r.bank_name)}${r.bank_username ? ` (${r.bank_username})` : ''}`, r.sq ?? '', r.no ?? '',
        `${r.tirage_code}-${r.tirage_name}`, r.online ? 'Online' : 'Local', r.total_amount, r.time,
        r.is_deleted ? 'Oui' : 'Non',
      ]),
      [],
      ['Grand Total', '', '', '', '', '', data.grand_total, '', ''],
    ]);
  };

  return (
    <Layout>
      <p className="tv-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/rapports" className="bc-link">Rapports</Link>
        {' >> '}
        <span className="bc-current">Tickets Vendus</span>
      </p>

      <div className="tv-card">
        <div className="tv-card-header">
          <span className="tv-card-title">Vendu Tickets Rapport</span>
        </div>
        <div className="tv-card-body">
          <div className="tv-radio-row">
            {['Tout', 'Groupe', 'Superviseur', 'Banque'].map((opt) => (
              <label key={opt} className="tv-radio-label">
                <input
                  type="radio"
                  name="filter"
                  value={opt}
                  checked={filter === opt}
                  onChange={() => { setFilter(opt); setScopeId(''); setScopeName(''); }}
                />
                {opt}
              </label>
            ))}
          </div>

          {filter !== 'Tout' && (
            <div className="tv-row tv-scope-row">
              <label className="tv-label">{filter}</label>
              {filter === 'Banque' ? (
                <BankScopeField
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, name) => { setScopeId(id); setScopeName(name); }}
                  inputClass="tv-input tv-input-sm"
                  iconClass="tv-icon-btn"
                  nameClass="tv-lottery-name"
                  errClass="tv-lookup-err"
                />
              ) : (
                <ScopeField
                  filter={filter}
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                  inputClass="tv-input tv-input-sm"
                  iconClass="tv-icon-btn"
                  nameClass="tv-lottery-name"
                  errClass="tv-lookup-err"
                />
              )}
            </div>
          )}

          <form onSubmit={handleSearch} className="tv-form">
            <div className="tv-row">
              <label className="tv-label">Date</label>
              <DateField className="tv-input tv-input-date" value={date} onChange={setDate} />
            </div>

            <div className="tv-row">
              <label className="tv-label">Loterie De</label>
              <LotteryCodeField
                value={lotteryFrom}
                name={lotteryFromName}
                onChange={(code) => { setLotteryFrom(code); setLotteryFromName(''); }}
                onResolve={(code, nm) => { setLotteryFrom(code); setLotteryFromName(nm); }}
                inputClass="tv-input tv-input-sm"
                iconClass="tv-icon-btn"
                nameClass="tv-lottery-name"
              />

              <label className="tv-label tv-label-to">Loterie Up</label>
              <LotteryCodeField
                value={lotteryUp}
                name={lotteryUpName}
                onChange={(code) => { setLotteryUp(code); setLotteryUpName(''); }}
                onResolve={(code, nm) => { setLotteryUp(code); setLotteryUpName(nm); }}
                inputClass="tv-input tv-input-sm"
                iconClass="tv-icon-btn"
                nameClass="tv-lottery-name"
              />
            </div>

            <div className="tv-row">
              <label className="tv-label">Statut</label>
              <select className="tv-select" value={statut} onChange={(e) => setStatut(e.target.value)}>
                {statutOptions.map((opt) => <option key={opt}>{opt}</option>)}
              </select>
            </div>

            {error && <p className="tv-error">{error}</p>}
            <button type="submit" className="tv-search-btn" disabled={loading}>
              {loading ? 'Recherche...' : 'Chercher'}
            </button>
          </form>
        </div>
      </div>

      {data && (
        <div className="tv-card tv-results">
          <div className="tv-card-header tv-results-header">
            <span className="tv-card-title">Vendu Tickets Rapport</span>
            {data.rows.length > 0 && (
              <button type="button" className="tv-download-btn" onClick={handleDownload}>Télécharger</button>
            )}
          </div>
          <div className="tv-card-body">
            <p className="tv-info-bar">Date : {data.date} — {data.count} ticket(s) — Total : <strong>{money(data.grand_total)}</strong> — cliquer une fiche pour voir le detail</p>
            {data.rows.length === 0 ? (
              <p className="tv-empty">Aucune fiche sur cette portée/période.</p>
            ) : (
              <table className="tv-table">
                <thead>
                  <tr>
                    <th>Date</th><th>Banque</th><th>SQ</th><th>Loterie</th>
                    <th>O/L</th><th>Ticket</th><th>Montant</th><th>Temp</th>
                    <th>Utilisateur</th><th>Annulé?</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((r) => (
                    <tr
                      key={r.ticket_id}
                      className="tvm-clickable-row"
                      title="Voir le detail de la fiche"
                      onClick={() => setOpenTicketId(r.ticket_id)}
                    >
                      <td>{r.date}</td>
                      <td>{bankLabel(r.bank_seq, r.bank_name)}</td>
                      <td>{r.sq ?? '—'}</td>
                      <td>{r.tirage_code}-{r.tirage_name}</td>
                      <td>{r.online ? 'Online' : 'Local'}</td>
                      <td>{r.no ?? '—'}</td>
                      <td>{money(r.total_amount)}</td>
                      <td>{r.time}</td>
                      <td>{r.bank_username}</td>
                      <td>{r.is_deleted ? 'Oui' : 'Non'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {openTicketId != null && (
        <TicketViewModal
          ticketId={openTicketId}
          fetcher={fetchTicketDetail}
          onClose={() => setOpenTicketId(null)}
        />
      )}
    </Layout>
  );
};

export default TicketsVendusPage;
